module.exports = __webpack_public_path__ + "img/index03.28da968a.svg";